import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  useTheme,
} from "@mui/material";
import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useAddExpenseMutation } from "state/api";
import { validationSchemaAdd } from "./validationSchema";
import { useFormik } from "formik";
import { expensesCategories, paymentModes } from "./expenseDropdown";

const styles = {
  button: "bg-[#3671D5] hover:bg-[#114AAA] text-white ",
  cancelBtn: "bg-red-500 hover:bg-red-600 text-white",
};

const AddExpense = () => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      category: "",
      expenseAmount: "",
      date: null,
      paymentMode: "",
      description: "",
    },
    validationSchema: validationSchemaAdd,
    onSubmit: (values) => {
      // submit the form using rtk query mutation and close the dialog
      addNewExpense(values)
        .unwrap()
        .then((res) => {
          alert("Expense added successfully");
        })
        .catch((err) => {
          alert("Error adding Expense");
        });
      // above code can be replaced with a toast notification

      //   reset the form fields
      formik.resetForm();
      setOpen(false);
    },
  });
  const [addNewExpense] = useAddExpenseMutation();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Button
        variant="contained"
        size="large"
        className="bg-[#1A1A20] text-gray-50 hover:bg-slate-700"
        onClick={handleClickOpen}
      >
        Add Expense
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
          },
          // change label color
          "& .MuiInputLabel-root": {
            color: theme.palette.primary[300],
          },
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle id="form-dialog-title">Add Expense</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To add new expense, please enter the details here.
            </DialogContentText>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <TextField
                margin="dense"
                id="expenseAmount"
                label="Amount"
                type="text"
                fullWidth
                value={formik.values.expenseAmount}
                onChange={formik.handleChange}
                error={
                  formik.touched.expenseAmount &&
                  Boolean(formik.errors.expenseAmount)
                }
                helperText={
                  formik.touched.expenseAmount && formik.errors.expenseAmount
                }
              />

              <Autocomplete
                margin="dense"
                id="category"
                options={expensesCategories}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("category", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Expense Category"
                    error={
                      formik.touched.category && Boolean(formik.errors.category)
                    }
                    helperText={
                      formik.touched.category && formik.errors.category
                    }
                  />
                )}
              />

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Expense Incurred On"
                    format="LL"
                    value={formik.values.date}
                    onChange={(newValue) => {
                      formik.setFieldValue("date", newValue);
                    }}
                    slotProps={{
                      textField: {
                        error:
                          formik.touched.date && Boolean(formik.errors.date),
                        helperText: formik.touched.date && formik.errors.date,
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <Autocomplete
                margin="dense"
                id="paymentMode"
                options={paymentModes}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("paymentMode", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Mode of Payment"
                    error={
                      formik.touched.paymentMode &&
                      Boolean(formik.errors.paymentMode)
                    }
                    helperText={
                      formik.touched.paymentMode && formik.errors.paymentMode
                    }
                  />
                )}
              />
            </div>
            <TextField
              margin="dense"
              id="description"
              label="Description"
              type="text"
              multiline
              rows={4}
              fullWidth
              value={formik.values.description}
              onChange={formik.handleChange}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} className={styles.cancelBtn}>
              Cancel
            </Button>
            <Button type="submit" className={styles.button}>
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default AddExpense;
